import React from "react";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import styles from "./Team.styles";

const Team = ({ children, headline }) => {
	const css = styles();

	return (
		<Box className="extension-team">
			{headline && (
				<Typography
					className={css.headline}
					color="textSecondary"
					dangerouslySetInnerHTML={{ __html: headline }}
					variant="overline"
					component="h3"
				/>
			)}
			<div className={clsx(css.container, "extension-team-container")}>
				{children &&
					children?.length > 0 &&
					children.map(item => {
						return <div key={item.key}>{item}</div>;
					})}
			</div>
		</Box>
	);
};

export default Team;
